import appCache, { cacheItems } from "./cache";
const NodeCache = require("node-cache");

const cache = new NodeCache({
  // 10 min
  stdTTL: 600,
  // 5 min
  checkperiod: 300
});

export default class SDK {
  constructor(options) {
    this.baseUrl = options.baseUrl;
  }

  async checkReferralCode(data) {
    const url = `${this.baseUrl}/check-referral-code`;

    let res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          appCache.getItem(cacheItems.USER_TOKEN) == null
            ? undefined
            : `Bearer ${appCache.getItem(cacheItems.USER_TOKEN)}`,
        "x-ff-label": appCache.getItem(cacheItems.FF_LABELING) ?? undefined
      },
      body: JSON.stringify(data)
    });

    const json = await res.json();

    if (!res.ok) {
      return { error: json, status: res.status };
    }

    cache.flushAll();

    const out = { data: json, status: res.status };

    return out;
  }

  async getReferralCode() {
    const url = `${this.baseUrl}/referral-code`;
    const cacheKey = `GET${url}`;

    const cached = cache.get(cacheKey);

    if (cached !== undefined) {
      return cached;
    }

    let res = await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          appCache.getItem(cacheItems.USER_TOKEN) == null
            ? undefined
            : `Bearer ${appCache.getItem(cacheItems.USER_TOKEN)}`,
        "x-ff-label": appCache.getItem(cacheItems.FF_LABELING) ?? undefined
      }
    });

    const json = await res.json();

    if (!res.ok) {
      return { error: json, status: res.status };
    }

    const out = { data: json, status: res.status };
    cache.set(cacheKey, out);

    return out;
  }
}
